@if (imagesPassedIn) {
  <div class="images-viewer-dialog-wrapper" cdkFocusRegionstart>
    <div class="close-btn-wrapper">
      <button mat-icon-button class="close-btn" aria-label="Close" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="images-viewer-dialog-header">
      <div class="viewer-dialog-header-title">
        Photos of {{ titleName | titlecase }}
      </div>
    </div>
    <div class="images-viewer-dialog-content">
      <div class="images-viewer-list">
        @for (_imageData of imagesPassedIn; track _imageData) {
          <div class="images-viewer-item">
            @if (_imageData?.photo) {
              <div class="images-viewer-item-thumbnail">
                @if (currentUser && currentUser.userType === 'System Admin') {
                  <button mat-icon-button color="warn" class="delete-photo-control" aria-label="Close"
                    (click)="confirmDeleteItem(_imageData)" [matTooltip]="'Delete'" [matTooltipPosition]="'above'">
                    <span class="material-icons">close</span>
                  </button>
                }
                <img [src]="_imageData.photo">
                @if (_imageData?.html_attributions[0]) {
                  <figcaption class="images-viewer-item-cite">
                    Photo By: <span [innerHTML]="_imageData.html_attributions[0] | safeHtml" [matTooltip]="_imageData?.citeToolTip" [matTooltipPosition]="'above'"></span>
                  </figcaption>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
